import { render, staticRenderFns } from "./SelectRole.vue?vue&type=template&id=007bf946"
import script from "./SelectRole.vue?vue&type=script&lang=js"
export * from "./SelectRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports